// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Review_wrapper__3zeQi","leftColumn":"Review_leftColumn__1KbO5","title":"Review_title__2uH4p","rightColumn":"Review_rightColumn__2BTma","text":"Review_text__HMUbL"};